import { handleActions } from 'redux-actions';
import actions from 'state/direct-order-recurring/drop-off/actionCreators';
import initialState from 'state/direct-order-recurring/drop-off/initial.state';

const dropOff = handleActions(
  {
    [actions.setAddDays]: (state, { payload: { addDays } }) => {
      return { ...state, addDays };
    },
  },
  initialState
);

export default dropOff;
